import clsx from "clsx"
import React, {useMemo} from "react"


type BasicSelectProps = {
  label?: string
  value?: string
  options: { value: string, label: string, disabled?: boolean }[]
  onChange?: (value: string | undefined) => void
  useEmptyOption?: boolean
  disabled?: boolean
  required?: boolean
  emptyOptionLabel?: string
}

const BasicSelect: React.FC<BasicSelectProps> = (
    {label, value, options, onChange, useEmptyOption, disabled, required, emptyOptionLabel = "Select Option"}
) => {

  const className = useMemo(() => {
    return clsx(
        "focus:outline focus:outline-blue h-10 w-full shadow-md rounded-md max-h-20 px-4 outline-none bg-white",
        {
          "opacity-50": disabled
        }
    )
  }, [disabled])


  return <div className={"flex flex-col"}>
    {label && <label className={"mb-1"}>{label}{required && <span className="text-dark-red"> *</span>}</label>}

    <select
        disabled={disabled}
        className={className}
        onChange={(e) => onChange && onChange(e.target.value)}
        value={value}
    >
      {useEmptyOption && <option value={""}>
        {emptyOptionLabel}
      </option>}
      {options.map((o) => <option key={o.value} value={o.value} disabled={o.disabled}>{o.label}</option>)}
    </select>
  </div>
}

export default BasicSelect